import { IEducationalScenarioItem } from "../../educational-scenario-items";
import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";

export type IEducationalScenarioItemPatchMutationParameters = {
    educationalScenarioItem: RelationalValue<IEducationalScenarioItem>;
    educationalBriefsToSort: string[];
};

export type IEducationalScenarioItemPatchMutationResult = IEducationalScenarioItem;

export const educationalScenarioItemPatchMutation: IApiMutationFunction<
    IEducationalScenarioItemPatchMutationParameters
> = ({ educationalBriefsToSort, educationalScenarioItem }) => {
    return {
        method: "PATCH",
        url: `/educational_scenario_items/${mapRelationalValue(educationalScenarioItem)}/reorder`,
        headers: {
            "Content-Type": "application/merge-patch+json",
        },
        data: {
            educationalBriefsToSort,
        },
    };
};

export const useEducationalScenarioItemPatchMutation = createApiMutationHook<
    IEducationalScenarioItemPatchMutationParameters,
    IEducationalScenarioItemPatchMutationResult
>(educationalScenarioItemPatchMutation);
